import { FC, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ModalComponent } from 'componets/common';
import { VerifyQrCode } from './VerifyQRCode';
import { VerifyCode } from './VerifyCode';
import { VerifySuccessful } from './VerifySuccessful';

import { Verify2FAProps } from 'models/form';

import { useAppSelector, usePreventScroll, useAppDispatch } from 'hooks';

import { getQRCode } from 'features/verify2FA/actions';
import { closeVerify } from 'features/verify2FA/verify2FASlice';

import { Paths, RequestStatus } from 'utils/constants';

import { ReactComponent as SuccessIcon } from 'assets/icons/success-verify.svg';

const TITLES = ['verifyTitle1Text', 'verifyTitle2Text', 'verifyTitle3Text'];

export const Verify2FASteps: FC<Verify2FAProps> = ({ isOpen, onClose, isSettings }) => {
	const { step, statusQRCode } = useAppSelector((state) => state.verify2FA);

	usePreventScroll();

	const { t } = useTranslation();

	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(getQRCode());
	}, [dispatch]);

	let Component = VerifyQrCode;

	if (step === 2) {
		Component = VerifyCode;
	}
	if (step === 3) {
		Component = VerifySuccessful;
	}

	const title = useMemo(() => TITLES[step - 1], [step]);

	if (statusQRCode === RequestStatus.PENDING) return null;

	const onEnd = () => {
		dispatch(closeVerify());
		isSettings ? onClose() : navigate(Paths.VERIFY_IDENTITY);
	};

	return (
		<ModalComponent
			isOpen={isOpen}
			onClose={step === 3 ? onEnd : onClose}
			title={t(title)}
			icon={step === 3 && <SuccessIcon />}
		>
			<Component onClose={step === 3 ? onEnd : onClose} />
		</ModalComponent>
	);
};
